







































import { Vue, Component } from 'vue-property-decorator';
import VoteList from '../components/VoteList.vue';

@Component({
  components: {
    VoteList,
  },
})
export default class Home extends Vue {
  active = 0;
  tempValue = '';
  searchWords: string = '';
  type = 1;
  tabs = [
    { id: 1, text: '重庆商业典范' },
    { id: 5, text: '最佳智能手机' },
    { id: 4, text: '最具影响力网络出行品牌' },
    { id: 2, text: '最具影响力家电品牌' },
    { id: 3, text: '最具影响力家电卖场' },
    { id: 6, text: '最具影响力家居卖场<br>候选品牌展示' },
    { id: 7, text: '最具影响力装饰公司<br>候选品牌展示' },
    { id: 8, text: '最具竞争力装饰公司<br>候选品牌展示' },
    { id: 9, text: '最受欢迎建材品牌<br>候选品牌展示' },
  ];

  handleClickTab(index: number, id: number) {
    this.tempValue = '';
    this.searchWords = '';
    this.active = index;
    this.type = id;
  }
  handleClickSearch() {
    this.searchWords = this.tempValue;
    // this.searchWords = (this.$refs.input as HTMLInputElement).value;
  }
  enterDetailPage(id: number) {
    const onlyShowTypes = [6, 7, 8, 9];
    if (onlyShowTypes.includes(this.active + 1)) {
      this.$router.push({
        path: 'detail',
        query: {
          id: String(id),
          type: String(this.type),
        },
      });
    }
  }
}
